import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ContactConfirmation } from 'components/contact-confirmation'
import { REGISTRATION_DATA_STAGES } from 'app-constants'
import {
  EmailList,
  EmailAdd,
  EmailConfirmation,
  EmailSuccess,
  EmailDelete,
  EmailSelectDefault,
} from './components'

export function EmailDrawer() {
  const [data, setData] = useState({})
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages({ data, setData })[stage]
}

function stages({ ...props }) {
  return {
    initial: <EmailList {...props} />,
    add: <EmailAdd {...props} />,
    confirmation: <EmailConfirmation {...props} />,
    success: <EmailSuccess {...props} />,
    select_default: <EmailSelectDefault {...props} />,
    delete: <EmailDelete {...props} />,
    contact_confirmation: (
      <ContactConfirmation {...props} nextStage={REGISTRATION_DATA_STAGES.SUCCESS} />
    ),
  }
}
